import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";

function FilterUserGroup({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    group_name: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.group_name) {
      condition.group_name = {
        $regex: filter.group_name.split(" ").join(".*"),
      };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Tên nhóm"
        placeholder="Tìm theo tên nhóm"
        value={filter.group_name}
        onSearch={(val) => setFilter({ ...filter, group_name: val })}
      />
    </WrapperFilter>
  );
}

export default FilterUserGroup;
